<template>
  <s-modal
    v-model="showModal"
    class="temporary-password"
    footer-class="temporary-password__footer"
    :title="$t(`user-manager.reset-password-modal.offline.title`)"
    :ok-title="$t(`user-manager.reset-password-modal.offline.close-button`)"
    :cancel-title="$t(`user-manager.reset-password-modal.offline.email-button`)"
    :is-loading="isLoading"
    :ok-only="isOffLineMode"
    @cancel="emitEmailEvent"
    @ok="closeModal"
    @hide="closeModal"
  >
    <div class="temporary-password__content">
      <div class="temporary-password__copy-content">
        <input-copy-content
          v-model="password"
          class="temporary-password__pass-input"
          box-mode
          disabled
        />
      </div>
      <div v-html="$t('user-manager.reset-password-modal.offline.message', {
          eMail,
        })">
      </div>
    </div>
  </s-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import InputCopyContent from '@/components/inputs/InputCopyContent';

export default {
  components: {
    InputCopyContent,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    password: null,
    eMail: null,
    showModal: false,
  }),
  computed: {
    ...mapGetters([
      'isOffLineMode',
    ]),
  },
  methods: {
    show(password, eMail) {
      this.password = password;
      this.eMail = eMail;
      this.showModal = true;
    },
    closeModal() {
      this.$emit('ok');
      this.showModal = false;
    },
    emitEmailEvent() {
      this.$emit('send-email');
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .temporary-password
    &__content
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
    &__copy-content
      width: 80%
    &__pass-input
      font-size: 2em
      width: 100%
      margin-bottom: 1em
    +media-min-sm()
      &__copy-content
        width: 60%
    +media-min-md()
    +media-min-lg()
</style>
